import { render, staticRenderFns } from "./subirarchivo.vue?vue&type=template&id=2a68cfab&"
import script from "./subirarchivo.vue?vue&type=script&lang=ts&"
export * from "./subirarchivo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports